import { render, staticRenderFns } from "./GoHmTipPage.vue?vue&type=template&id=145ba483&scoped=true&"
import script from "./GoHmTipPage.vue?vue&type=script&lang=js&"
export * from "./GoHmTipPage.vue?vue&type=script&lang=js&"
import style0 from "./GoHmTipPage.vue?vue&type=style&index=0&id=145ba483&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ba483",
  null
  
)

export default component.exports